import { Empty } from 'antd';

import { TitleWrapper } from '@page/webhooks/webhooks.style';
import { PageTitle, PageWrapper } from '@style/pages/page.style';

import { Table } from '@atom/table/table';
import { useCurrentApplication } from '@hook/application/use-current-application.hook';
import { isExist } from '@util/data/is-exist';

import { NewWebhook } from './new-webhook/new-webhook';
import { TriggerEvent } from './trigger-event';
import { WebhookInfo } from './webhook-info/webhook-info';
import { WebhookSecret } from './webhook-secret/webhook-secret';
import { useConsumerWebhooks } from './webhooks.hook';
import { consumerWebhookColumns } from './webhooks.options';

export const WebhooksPage = () => {
  const { current } = useCurrentApplication();
  const { data, isLoading } = useConsumerWebhooks();

  return (
    <PageWrapper>
      {isExist(current.webhookSecret) && <WebhookSecret secret={current.webhookSecret} />}
      <TitleWrapper>
        <PageTitle>Webhooks</PageTitle>
        <div style={{ display: 'flex' }}>
          <TriggerEvent />
          <NewWebhook />
        </div>
      </TitleWrapper>
      <Table
        columns={consumerWebhookColumns}
        dataSource={data}
        expandable={{ expandedRowRender: WebhookInfo }}
        loading={isLoading}
        locale={{ emptyText: <Empty description='No webhooks' image={Empty.PRESENTED_IMAGE_SIMPLE} /> }}
        pagination={false}
        rowKey='id'
      />
    </PageWrapper>
  );
};
